import { ROUTES_PATHS } from '@/app.constants';
import abilityMapping from '@/config/acl/ability-mapping';
import { ROUTES_KEYS_MAP } from '@/config/router/key-routes-mapping';
import { AdHocActivitiesLogo, BillingLogo, CityMappingLogo, CountryLogo, GetOrdersLogo, HomeLogo, HubsLogo, MappingLogo, OmnifulCityLogo, OrderLogo, PricingPlansLogo, SalesChannelAppsLogo, SellerLogo, SettingsLogo, SkuLogo, StateLogo, TenantLogo, ThreeBillingPLLogo } from '@/data/assets';
import { iPrimaryNavbarItem } from '@/types/app.types';

export type iLayoutTypes =
  | '_partner_layout'
  | '_blank_layout'

export const primaryMenuItems: iPrimaryNavbarItem[] = [

  // HOME MODULE
  {
    id: '_p_nav_home',
    navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.HOME],
    routeKeys: [ROUTES_KEYS_MAP.HOME],
    title: 'Home',
    icon: HomeLogo,
    permissions: [
      {
        action: abilityMapping.module.view.action,
        subject: abilityMapping.module.view.subject
      }
    ]
  },

  // MAPPING MODULE
  {
    id: '_p_nav_mapping',
    navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.CITY_MAPPING],
    routeKeys: [
      ROUTES_KEYS_MAP.CITY_MAPPING,
      ROUTES_KEYS_MAP.OMNIFUL_CITIES,
      ROUTES_KEYS_MAP.OMNIFUL_COUNTRY_CITIES,
      // ROUTES_KEYS_MAP.SHIPPING_PARTNER_CITY_MAPPING,
      // ROUTES_KEYS_MAP.SALES_CHANNEL_CITY_MAPPING,
      ROUTES_KEYS_MAP.OMNIFUL_COUNTRY,
      ROUTES_KEYS_MAP.OMNIFUL_STATE
    ],
    title: 'Mapping',
    icon: MappingLogo,
    permissions: [
      {
        action: abilityMapping.city_mapping.view.action,
        subject: abilityMapping.city_mapping.view.subject
      },
      // {
      //   action: abilityMapping.shipping_partner_city_mapping.view.action,
      //   subject: abilityMapping.shipping_partner_city_mapping.view.subject
      // },
      // {
      //   action: abilityMapping.sales_channel_city_mapping.view.action,
      //   subject: abilityMapping.sales_channel_city_mapping.view.subject
      // },
      {
        action: abilityMapping.city.view.action,
        subject: abilityMapping.city.view.subject
      },
      {
        action: abilityMapping.state.view.action,
        subject: abilityMapping.state.view.subject
      },
      {
        action: abilityMapping.country.view.action,
        subject: abilityMapping.country.view.subject
      }
    ],
    secondaryNavbar: {
      id: '_s_nav_mapping',
      navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.CITY_MAPPING],
      routeKeys: [ROUTES_KEYS_MAP.CITY_MAPPING],
      headerTitle: 'Mapping',
      children: [
        {
          id: '_s_nav_mapping_city',
          navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.CITY_MAPPING],
          routeKeys: [ROUTES_KEYS_MAP.CITY_MAPPING],
          title: 'City Mapping',
          icon: CityMappingLogo,
          permissions: [
            {
              action: abilityMapping.city_mapping.view.action,
              subject: abilityMapping.city_mapping.view.subject
            }
          ],
        },
        // {
        //   id: '_s_nav_mapping_tenant',
        //   navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.SHIPPING_PARTNER_CITY_MAPPING],
        //   routeKeys: [ROUTES_KEYS_MAP.SHIPPING_PARTNER_CITY_MAPPING, ROUTES_KEYS_MAP.SALES_CHANNEL_CITY_MAPPING],
        //   title: 'Tenant City Mapping',
        //   icon: TenantMappingLogo,
        //   permissions: [
        //     {
        //       action: abilityMapping.shipping_partner_city_mapping.view.action,
        //       subject: abilityMapping.shipping_partner_city_mapping.view.subject
        //     },
        //     {
        //       action: abilityMapping.sales_channel_city_mapping.view.action,
        //       subject: abilityMapping.sales_channel_city_mapping.view.subject
        //     }
        //   ],
        //   children: [
        //     {
        //       id: '_s_nav_mapping_shipping_partner_city',
        //       navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.SHIPPING_PARTNER_CITY_MAPPING],
        //       routeKeys: [ROUTES_KEYS_MAP.SHIPPING_PARTNER_CITY_MAPPING],
        //       title: 'Shipping Partner',
        //       permissions: [
        //         {
        //           action: abilityMapping.shipping_partner_city_mapping.view.action,
        //           subject: abilityMapping.shipping_partner_city_mapping.view.subject
        //         }
        //       ],
        //     },
        //     // {
        //     //   id: '_s_nav_mapping_sales_channel_city',
        //     //   navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.SALES_CHANNEL_CITY_MAPPING],
        //     //   routeKeys: [ROUTES_KEYS_MAP.SALES_CHANNEL_CITY_MAPPING],
        //     //   title: 'Sales Channel',
        //     //   permissions: [
        //     //     {
        //     //       action: abilityMapping.sales_channel_city_mapping.view.action,
        //     //       subject: abilityMapping.sales_channel_city_mapping.view.subject
        //     //     }
        //     //   ],
        //     // }
        //   ]
        // },
        {
          id: '_s_nav_mapping_index',
          navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.OMNIFUL_CITIES],
          routeKeys: [ROUTES_KEYS_MAP.OMNIFUL_CITIES],
          title: 'Omniful Cities',
          icon: OmnifulCityLogo,
          permissions: [
            {
              action: abilityMapping.city.view.action,
              subject: abilityMapping.city.view.subject
            }
          ],
        },
        {
          id: '_s_nav_mapping_omniful_state',
          navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.OMNIFUL_STATE],
          routeKeys: [ROUTES_KEYS_MAP.OMNIFUL_STATE],
          title: 'Omniful States',
          icon: StateLogo,
          permissions: [
            {
              action: abilityMapping.state.view.action,
              subject: abilityMapping.state.view.subject
            }
          ],
        },
        {
          id: '_s_nav_mapping_omniful_country',
          navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.OMNIFUL_COUNTRY],
          routeKeys: [ROUTES_KEYS_MAP.OMNIFUL_COUNTRY],
          title: 'Omniful Countries',
          icon: CountryLogo,
          permissions: [
            {
              action: abilityMapping.country.view.action,
              subject: abilityMapping.country.view.subject
            }
          ],
        }
      ],
    },
  },
  {
    id: '_p_nav_tenants',
    navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.TENANTS],
    routeKeys: [ROUTES_KEYS_MAP.TENANTS],
    title: 'Tenants',
    icon: TenantLogo,
    permissions: [
      {
        action: abilityMapping.tenant.view.action,
        subject: abilityMapping.tenant.view.subject
      }
    ],
  },
  {
    id: '_p_nav_orders',
    navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.ORDERS],
    routeKeys: [ROUTES_KEYS_MAP.ORDERS],
    title: 'Orders',
    icon: OrderLogo,
    permissions: [
      {
        action: abilityMapping.sales_channel_app.view.action,
        subject: abilityMapping.sales_channel_app.view.subject
      }
    ],
    secondaryNavbar: {
      id: '_s_nav_orders',
      navLink: '/',
      routeKeys: [ROUTES_KEYS_MAP.ORDERS],
      headerTitle: 'Orders',
      children: [
        {
          id: '_s_nav_orders_list',
          navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.ORDERS],
          routeKeys: [ROUTES_KEYS_MAP.ORDERS],
          title: 'Order Details',
          icon: GetOrdersLogo,
          permissions: [
            {
              action: abilityMapping.sales_channel_app.view.action,
              subject: abilityMapping.sales_channel_app.view.subject
            }
          ],
        }
      ],
    }
  },
  {
    id: '_p_nav_billing',
    navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.BILLING_OMNIFUL_ENTITY],
    routeKeys: [
      ROUTES_KEYS_MAP.BILLING_OMNIFUL_ENTITY,
      ROUTES_KEYS_MAP.BILLING_TENANT_ENTITY,
      ROUTES_KEYS_MAP.BILLING_PROFILE,
      ROUTES_KEYS_MAP.BILLING_SINGLE_PROFILE,
      ROUTES_KEYS_MAP.BILLING_PROFILE_CREATE,
      ROUTES_KEYS_MAP.BILLING_CONTRACTS,
      ROUTES_KEYS_MAP.BILLING_SINGLE_CONTRACT,
      ROUTES_KEYS_MAP.BILLING_BILLS,
      ROUTES_KEYS_MAP.BILLING_SINGLE_BILL,
      ROUTES_KEYS_MAP.BILLING_TRANSACTIONS,
      ROUTES_KEYS_MAP.BILLING_AD_HOC_ACTIVITIES,
      ROUTES_KEYS_MAP.BILLING_AD_HOC_USAGE,
    ],
    title: 'Billing',
    icon: BillingLogo,
    permissions: [
      {
        action: abilityMapping.profile_billing.view.action,
        subject: abilityMapping.profile_billing.view.subject,
      },
      {
        action: abilityMapping.contract_billing.view.action,
        subject: abilityMapping.contract_billing.view.subject,
      },
      {
        action: abilityMapping.bill_billing.view.action,
        subject: abilityMapping.bill_billing.view.subject,
      },
      {
        action: abilityMapping.omniful_billing_account.view.action,
        subject: abilityMapping.omniful_billing_account.view.subject,
      },
      {
        action: abilityMapping.tenant_billing_account.view.action,
        subject: abilityMapping.tenant_billing_account.view.subject,
      },
      {
        action: abilityMapping.adhoc.view.action,
        subject: abilityMapping.adhoc.view.subject,
      },
      {
        action: abilityMapping.usage_adhoc.view.action,
        subject: abilityMapping.usage_adhoc.view.subject,
      },
    ],
    secondaryNavbar: {
      id: '_s_nav_billing',
      navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.BILLING_OMNIFUL_ENTITY],
      routeKeys: [
        ROUTES_KEYS_MAP.BILLING_OMNIFUL_ENTITY,
        ROUTES_KEYS_MAP.BILLING_TENANT_ENTITY,
        ROUTES_KEYS_MAP.BILLING_PROFILE,
        ROUTES_KEYS_MAP.BILLING_CONTRACTS,
        ROUTES_KEYS_MAP.BILLING_BILLS,
        ROUTES_KEYS_MAP.BILLING_TRANSACTIONS,
        ROUTES_KEYS_MAP.BILLING_AD_HOC_ACTIVITIES,
        ROUTES_KEYS_MAP.BILLING_AD_HOC_USAGE,
      ],
      headerTitle: 'Billing',
      children: [
        {
          id: '_s_nav_billing_entities_group',
          title: 'Account Management',
          icon: TenantLogo,
          navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.BILLING_OMNIFUL_ENTITY],
          routeKeys: [
            ROUTES_KEYS_MAP.BILLING_OMNIFUL_ENTITY,
            ROUTES_KEYS_MAP.BILLING_TENANT_ENTITY,
          ],
          permissions: [
            {
              action: abilityMapping.omniful_billing_account.view.action,
              subject: abilityMapping.omniful_billing_account.view.subject,
            },
            {
              action: abilityMapping.tenant_billing_account.view.action,
              subject: abilityMapping.tenant_billing_account.view.subject,
            },
          ],
          children: [
            {
              id: '_s_nav_billing_omniful_entity',
              navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.BILLING_OMNIFUL_ENTITY],
              routeKeys: [ROUTES_KEYS_MAP.BILLING_OMNIFUL_ENTITY],
              title: 'Omniful Billing Account',
              permissions: [
                {
                  action: abilityMapping.omniful_billing_account.view.action,
                  subject: abilityMapping.omniful_billing_account.view.subject,
                },
              ],
            },
            {
              id: '_s_nav_billing_tenant_entity',
              navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.BILLING_TENANT_ENTITY],
              routeKeys: [ROUTES_KEYS_MAP.BILLING_TENANT_ENTITY],
              title: 'Tenant Billing Account',
              permissions: [
                {
                  action: abilityMapping.tenant_billing_account.view.action,
                  subject: abilityMapping.tenant_billing_account.view.subject,
                },
              ],
            },
          ],
        },
        {
          id: '_s_nav_billing_3pl_group',
          title: 'Billing Management',
          icon: ThreeBillingPLLogo,
          navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.BILLING_PROFILE],
          routeKeys: [
            ROUTES_KEYS_MAP.BILLING_PROFILE,
            ROUTES_KEYS_MAP.BILLING_PROFILE_CREATE,
            ROUTES_KEYS_MAP.BILLING_SINGLE_PROFILE,
            ROUTES_KEYS_MAP.BILLING_CONTRACTS,
            ROUTES_KEYS_MAP.BILLING_SINGLE_CONTRACT,
            ROUTES_KEYS_MAP.BILLING_BILLS,
            ROUTES_KEYS_MAP.BILLING_SINGLE_BILL,
            ROUTES_KEYS_MAP.BILLING_TRANSACTIONS,
          ],
          permissions: [
            {
              action: abilityMapping.profile_billing.view.action,
              subject: abilityMapping.profile_billing.view.subject,
            },
            {
              action: abilityMapping.contract_billing.view.action,
              subject: abilityMapping.contract_billing.view.subject,
            },
            {
              action: abilityMapping.bill_billing.view.action,
              subject: abilityMapping.bill_billing.view.subject,
            },
          ],
          children: [
            {
              id: '_s_nav_billing_profile',
              navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.BILLING_PROFILE],
              routeKeys: [ROUTES_KEYS_MAP.BILLING_PROFILE, ROUTES_KEYS_MAP.BILLING_PROFILE_CREATE, ROUTES_KEYS_MAP.BILLING_SINGLE_PROFILE],
              title: 'Billing Profile',
              permissions: [
                {
                  action: abilityMapping.profile_billing.view.action,
                  subject: abilityMapping.profile_billing.view.subject,
                },
              ],
            },
            {
              id: '_s_nav_billing_contracts',
              navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.BILLING_CONTRACTS],
              routeKeys: [ROUTES_KEYS_MAP.BILLING_CONTRACTS, ROUTES_KEYS_MAP.BILLING_SINGLE_CONTRACT],
              title: 'Contracts',
              permissions: [
                {
                  action: abilityMapping.contract_billing.view.action,
                  subject: abilityMapping.contract_billing.view.subject,
                },
              ],
            },
            {
              id: '_s_nav_billing_bills',
              navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.BILLING_BILLS],
              routeKeys: [ROUTES_KEYS_MAP.BILLING_BILLS, ROUTES_KEYS_MAP.BILLING_SINGLE_BILL],
              title: 'Invoices',
              permissions: [
                {
                  action: abilityMapping.bill_billing.view.action,
                  subject: abilityMapping.bill_billing.view.subject,
                },
              ],
            },
            {
              id: '_s_nav_billing_transactions',
              navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.BILLING_TRANSACTIONS],
              routeKeys: [ROUTES_KEYS_MAP.BILLING_TRANSACTIONS],
              title: 'Transactions',
              permissions: [
                {
                  action: abilityMapping.bill_billing.view.action,
                  subject: abilityMapping.bill_billing.view.subject,
                },
              ],
            },
          ],
        },
        {
          id: '_s_nav_billing_adhoc_group',
          title: 'Ad-Hoc Management',
          icon: AdHocActivitiesLogo,
          navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.BILLING_AD_HOC_ACTIVITIES],
          routeKeys: [
            ROUTES_KEYS_MAP.BILLING_AD_HOC_ACTIVITIES,
            ROUTES_KEYS_MAP.BILLING_AD_HOC_USAGE,
          ],
          permissions: [
            {
              action: abilityMapping.adhoc.view.action,
              subject: abilityMapping.adhoc.view.subject,
            },
            {
              action: abilityMapping.usage_adhoc.view.action,
              subject: abilityMapping.usage_adhoc.view.subject,
            },
          ],
          children: [
            {
              id: '_s_nav_billing_ad_hoc_activities',
              navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.BILLING_AD_HOC_ACTIVITIES],
              routeKeys: [ROUTES_KEYS_MAP.BILLING_AD_HOC_ACTIVITIES],
              title: 'Ad Hoc Activities',
              permissions: [
                {
                  action: abilityMapping.adhoc.view.action,
                  subject: abilityMapping.adhoc.view.subject,
                },
              ],
            },
            {
              id: '_s_nav_billing_ad_hoc_usage',
              navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.BILLING_AD_HOC_USAGE],
              routeKeys: [ROUTES_KEYS_MAP.BILLING_AD_HOC_USAGE],
              title: 'Ad Hoc Usage',
              permissions: [
                {
                  action: abilityMapping.usage_adhoc.view.action,
                  subject: abilityMapping.usage_adhoc.view.subject,
                },
              ],
            },
          ],
        },
      ],
    },
  },
  {
    id: '_p_nav_seller',
    navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.SELLER],
    routeKeys: [ROUTES_KEYS_MAP.SELLER],
    title: 'Seller',
    icon: SellerLogo,
    permissions: [
      {
        action: abilityMapping.seller.view.action,
        subject: abilityMapping.seller.view.subject
      }
    ],
  },
  {
    id: '_p_nav_skus',
    navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.SKUS],
    routeKeys: [ROUTES_KEYS_MAP.SKUS],
    title: 'SKUs',
    icon: SkuLogo,
    permissions: [
      {
        action: abilityMapping.sku.view.action,
        subject: abilityMapping.sku.view.subject
      }
    ],
  },
  {
    id: '_p_nav_hubs',
    navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.HUBS],
    routeKeys: [ROUTES_KEYS_MAP.HUBS],
    title: 'Hubs',
    icon: HubsLogo,
    permissions: [
      {
        action: abilityMapping.hub.view.action,
        subject: abilityMapping.hub.view.subject
      }
    ],
  },

  // SETTINGS MODULE
  {
    id: '_p_nav_settings',
    navLink: '/settings/sales-channel-apps',
    routeKeys: [
      ROUTES_KEYS_MAP.SETTINGS,
      ROUTES_KEYS_MAP.SALES_CHANNEL_APPS,
      ROUTES_KEYS_MAP.SELLER_SALES_CHANNELS,
      ROUTES_KEYS_MAP.SHIPPING_APPS_CONFIG,
      ROUTES_KEYS_MAP.USERS_SETTINGS,
      ROUTES_KEYS_MAP.ROLES_SETTINGS,
      ROUTES_KEYS_MAP.PRICING_PLANS
    ],
    title: 'Settings',
    icon: SettingsLogo,
    permissions: [
      {
        action: abilityMapping.sales_channel_app.view.action,
        subject: abilityMapping.sales_channel_app.view.subject
      },
      {
        action: abilityMapping.omniful_user.view.action,
        subject: abilityMapping.omniful_user.view.subject
      },
      {
        action: abilityMapping.omniful_role.view.action,
        subject: abilityMapping.omniful_role.view.subject
      },
      {
        action: abilityMapping.shipping_app.view.action,
        subject: abilityMapping.shipping_app.view.subject
      },
      {
        action: abilityMapping.pricing_plans.view.action,
        subject: abilityMapping.pricing_plans.view.subject
      }
    ],
    secondaryNavbar: {
      id: '_s_nav_settings',
      navLink: '/',
      routeKeys: [ROUTES_KEYS_MAP.SETTINGS],
      headerTitle: 'Settings',
      children: [
        {
          id: '_s_nav_settings_sales_channel_apps',
          navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.SALES_CHANNEL_APPS],
          routeKeys: [ROUTES_KEYS_MAP.SALES_CHANNEL_APPS, ROUTES_KEYS_MAP.SELLER_SALES_CHANNELS, ROUTES_KEYS_MAP.SHIPPING_APPS_CONFIG],
          title: 'Apps & Integrations',
          icon: SalesChannelAppsLogo,
          permissions: [
            {
              action: abilityMapping.sales_channel_app.view.action,
              subject: abilityMapping.sales_channel_app.view.subject
            },
            {
              action: abilityMapping.shipping_app.view.action,
              subject: abilityMapping.shipping_app.view.subject
            },
          ],
          children: [
            {
              id: '_s_nav_settings_sales_channel_apps_list',
              navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.SALES_CHANNEL_APPS],
              routeKeys: [ROUTES_KEYS_MAP.SALES_CHANNEL_APPS],
              title: 'Sales Channel Apps',
              permissions: [
                {
                  action: abilityMapping.sales_channel_app.view.action,
                  subject: abilityMapping.sales_channel_app.view.subject
                }
              ],
            },
            {
              id: '_s_nav_settings_seller_sales_channels',
              navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.SELLER_SALES_CHANNELS],
              routeKeys: [ROUTES_KEYS_MAP.SELLER_SALES_CHANNELS],
              title: 'Seller Sales Channels',
              permissions: [
                {
                  action: abilityMapping.sales_channel_app.view.action,
                  subject: abilityMapping.sales_channel_app.view.subject
                }
              ],
            },
            {
              id: '_s_nav_settings_shipping_config_apps',
              navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.SHIPPING_APPS_CONFIG],
              routeKeys: [ROUTES_KEYS_MAP.SHIPPING_APPS_CONFIG],
              title: 'Shipping Apps Config',
              permissions: [
                {
                  action: abilityMapping.shipping_app.view.action,
                  subject: abilityMapping.shipping_app.view.subject
                }
              ],
            }
          ] 
        },
        {
          id: '_s_nav_settings_users_settings',
          navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.USERS_SETTINGS],
          routeKeys: [ROUTES_KEYS_MAP.USERS_SETTINGS],
          title: 'Users Settings',
          icon: SettingsLogo,
          permissions: [
            {
              action: abilityMapping.omniful_user.view.action,
              subject: abilityMapping.omniful_user.view.subject
            }
          ],
        },
        {
          id: '_s_nav_settings_roles_settings',
          navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.ROLES_SETTINGS],
          routeKeys: [ROUTES_KEYS_MAP.ROLES_SETTINGS],
          title: 'Roles Settings',
          icon: SettingsLogo,
          permissions: [
            {
              action: abilityMapping.omniful_role.view.action,
              subject: abilityMapping.omniful_role.view.subject
            }
          ],
        },
        // PRICING PLANS MODULE
        {
          id: '_s_nav_settings_pricing_plans',
          navLink: ROUTES_PATHS[ROUTES_KEYS_MAP.PRICING_PLANS],
          routeKeys: [ROUTES_KEYS_MAP.PRICING_PLANS],
          title: 'Pricing Plans',
          icon: PricingPlansLogo,
          permissions: [
            {
              action: abilityMapping.pricing_plans.view.action,
              subject: abilityMapping.pricing_plans.view.subject
            }
          ]
        },
      ],
    }
  },
];
